.containerRoot {
    height: auto;
    min-width: 40rem;
    max-width: 40rem;
    width: 100%;
    z-index: var(--mantine-priority-highest);
    color: white;
    border-bottom-left-radius: 1.5rem;
    border-bottom-right-radius: 1.5rem;
    padding-bottom: 1rem;
    margin: unset;
    top: 120px;
    top: 110px;

    @media screen and (min-width: 1601px) {
        transform: translateX(-2.66rem);
    }

    @media screen and (max-width: 1600px) {
        min-width: 40rem;
        max-width: 40rem;
        transform: translateX(-2.66rem);
    }
    @media screen and (max-width: 1440px) {
        min-width: 36rem;
        max-width: 36rem;
    }
    @media screen and (max-width: 1280px) {
        min-width: 32rem;
        max-width: 32rem;
    }
    @media screen and (max-width: 1200px) {
        min-width: 26rem;
        max-width: 26rem;
        transform: none;
    }
    @media screen and (max-width: 1100px) {
        min-width: 20rem;
        max-width: 20rem;
        transform: none;
    }

    @media screen and (max-width: 1000px) {
        min-width: 13.5rem;
        max-width: 13.5rem;
        transform: none;
    }
}
